export type GossipCategory =
  | '明星黑料'
  | '网红黑料'
  | '综艺风波'
  | '直播带货'
  | '情感纠葛'
  | '塌房现场';

export const gossipCategories: GossipCategory[] = [
  '明星黑料',
  '网红黑料',
  '综艺风波',
  '直播带货',
  '情感纠葛',
  '塌房现场',
];

export interface GossipItem {
  id: number;
  title: string;
  category: GossipCategory;
  excerpt: string;
  detail: string;
  time: string;
  heat: string;
  source: string;
  tags: string[];
  image: string;
}

export const tickerItems: { id: number; text: string; time: string }[] = [
  { id: 1, text: '顶流男团成员被拍深夜接机神秘女子，后援会深夜发长文回应', time: '11:42' },
  { id: 2, text: '千万粉带货主播直播间数据遭扒，被指刷单冲榜', time: '11:15' },
  { id: 3, text: '新晋小花被曝剧组耍大牌，制片方晒出聊天记录回应', time: '10:58' },
  { id: 4, text: '演员夫妇婚变传闻再起，双方先后清空社交平台合照', time: '10:33' },
  { id: 5, text: '网红情侣账号被指背后公司运营，人设真实性遭质疑', time: '10:04' },
  { id: 6, text: '综艺剪辑争议持续发酵，多位嘉宾镜头被大幅删减', time: '09:47' },
  { id: 7, text: '选秀歌手遭前经纪公司起诉，违约金传闻满天飞', time: '09:20' },
  { id: 8, text: '短剧顶流私下聚会视频流出，评论区出现两极分化', time: '08:56' },
  { id: 9, text: '头部主播选品再翻车，美妆产品资质问题被追问', time: '08:31' },
  { id: 10, text: '剧集未播番位之争登上热搜，双方粉丝发起控评大战', time: '08:05' },
];

export const latestItems: GossipItem[] = [
  {
    id: 1,
    title: '顶流男团成员被拍深夜接机神秘女子，后援会连夜发布千字声明',
    category: '明星黑料',
    excerpt:
      '一段模糊的路边视频在网络流传，画面中疑似某顶流男团成员与同行女子举止亲密。后援会随后发布千字长文，称一切以官方信息为准，呼吁粉丝理性吃瓜。',
    detail:
      '据多个娱乐博主的说法，视频拍摄于某机场到达通道，时间约为凌晨一点。画面分辨率较低，人物面部难以辨认，仅能看清两人同行的轮廓。后援会在声明中强调，艺人的私人行程不应被过度解读，同时提醒粉丝注意甄别信息来源。截至目前，艺人所属工作室尚未作出进一步回应，相关话题仍在持续发酵。',
    time: '12 分钟前',
    heat: '98.6 万',
    source: '综合网络公开讨论',
    tags: ['顶流', '后援会', '深夜视频'],
    image:
      'https://readdy.ai/api/search-image?query=Blurred%20night%20city%20street%20with%20warm%20red%20and%20amber%20neon%20reflections%20on%20wet%20asphalt%2C%20abstract%20smoky%20dark%20background%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%20shadows%2C%20no%20people%2C%20no%20text%2C%20moody%20atmosphere&width=800&height=450&seq=gossip-latest-01&orientation=landscape',
  },
  {
    id: 2,
    title: '千万粉丝带货主播被指刷单冲榜，直播间人气数据遭网友逐帧分析',
    category: '直播带货',
    excerpt:
      '有网友整理出某带货主播近三场直播的在线人数曲线，指出其人气在整点前后出现异常波动，质疑存在刷单与虚假人气。主播方面暂未就具体数据作出说明。',
    detail:
      '梳理的截图显示，直播间在线人数多次在整点前后出现阶梯式跳变，且评论刷屏的账号昵称存在明显规律。业内人士分析称，人气波动也可能与平台推荐机制、投流时段调整有关，单凭曲线难以直接认定违规。事件的核心争议在于直播间数据的真实性，而这也是近年来直播带货行业反复被讨论的话题。',
    time: '38 分钟前',
    heat: '86.2 万',
    source: '综合网络公开讨论',
    tags: ['直播', '数据质疑', '带货'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20glowing%20bar%20charts%20and%20data%20curves%20floating%20in%20a%20dark%20studio%20space%20with%20red%20and%20amber%20light%20streaks%2C%20cinematic%20editorial%20technology%20background%2C%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20smoky%20moody%20lighting&width=800&height=450&seq=gossip-latest-02&orientation=landscape',
  },
  {
    id: 3,
    title: '新晋小花被曝剧组耍大牌，制片方晒聊天记录回应引发新一轮讨论',
    category: '明星黑料',
    excerpt:
      '有消息称某新晋女演员在剧组期间多次迟到、拒绝配合补拍。随后制片方在社交平台晒出部分聊天记录，表示合作过程总体顺利，但评论区对此说法看法不一。',
    detail:
      '聊天记录显示，双方就拍摄档期与补拍安排有过多次沟通，语气较为平和。制片方在回应中表示，影视拍摄涉及大量协调工作，出现调整属于常态，不希望被过度解读。也有剧组工作人员匿名发帖称，现场情况与网络传闻存在出入。目前该演员工作室未对此事作出单独回应。',
    time: '1 小时前',
    heat: '74.5 万',
    source: '综合网络公开讨论',
    tags: ['剧组', '聊天记录', '新晋小花'],
    image:
      'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20atmosphere%20with%20empty%20director%20chair%20and%20soft%20spotlights%2C%20dark%20moody%20background%20with%20warm%20amber%20glow%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20dramatic%20shadows&width=800&height=450&seq=gossip-latest-03&orientation=landscape',
  },
  {
    id: 4,
    title: '演员夫妇婚变传闻再起，双方先后清空社交平台合照引发猜测',
    category: '情感纠葛',
    excerpt:
      '有细心网友发现，某演员夫妇的社交账号中被清空了多张早前的合照，同时取消了互相点赞的痕迹。两人近期也未在公开场合同框，相关话题迅速登上讨论榜。',
    detail:
      '需要说明的是，清理社交内容与感情状况之间并不存在必然联系，艺人也可能出于整理账号、切换团队等原因调整主页。双方团队目前均未回应婚变说法。从公开信息看，两人最近一次互动停留在数月之前，具体关系状态尚无法确认，建议以当事人官方回应为准。',
    time: '2 小时前',
    heat: '69.8 万',
    source: '综合网络公开讨论',
    tags: ['婚变', '社交平台', '演员夫妇'],
    image:
      'https://readdy.ai/api/search-image?query=Two%20empty%20picture%20frames%20on%20a%20dark%20wall%20lit%20by%20a%20single%20warm%20amber%20spotlight%2C%20minimal%20cinematic%20editorial%20composition%2C%20moody%20high%20contrast%2C%20soft%20red%20bokeh%2C%20no%20people%2C%20no%20text%2C%20quiet%20melancholy%20atmosphere&width=800&height=450&seq=gossip-latest-04&orientation=landscape',
  },
  {
    id: 5,
    title: '网红情侣账号被指由公司运营，所谓日常互动疑似剧本拍摄',
    category: '网红黑料',
    excerpt:
      '某百万粉情侣博主被网友扒出多条视频存在相同取景与相似台词，疑似同一团队批量制作。还有前员工爆料称，账号人设与脚本均由运营公司统一策划。',
    detail:
      '网友整理的对比图显示，该账号多期内容在家具摆放、拍摄机位、语气节奏上高度一致。有自称前运营人员的账号发帖称，情侣身份属实，但剧情经过了艺术加工。目前该博主未对爆料作出正面回应，仅在新视频评论区表示视频均为真实生活记录。真假如何，仍有待更多信息。',
    time: '3 小时前',
    heat: '63.1 万',
    source: '综合网络公开讨论',
    tags: ['情侣博主', '剧本', '运营公司'],
    image:
      'https://readdy.ai/api/search-image?query=Ring%20light%20and%20camera%20tripod%20in%20an%20empty%20dark%20content%20studio%20with%20warm%20amber%20and%20red%20ambient%20glow%2C%20cinematic%20editorial%20background%2C%20moody%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=gossip-latest-05&orientation=landscape',
  },
  {
    id: 6,
    title: '综艺节目剪辑争议升级，多位嘉宾镜头被大幅删减观众直呼看不懂',
    category: '综艺风波',
    excerpt:
      '某热播综艺最新一期播出后，观众发现多位嘉宾的镜头时长骤减，部分剧情线出现断裂。节目组回应称因时长限制进行了正常调整，但剪辑逻辑仍引发大范围讨论。',
    detail:
      '有观众逐帧统计后指出，个别常驻嘉宾本期出镜不足一分钟，而新增环节占据大量篇幅。节目组人士向媒体表示，单期时长有限，剪辑需要在完整性与节奏之间取舍。业内观察者认为，综艺剪辑争议往往与招商、话题度等多重因素相关，观众看到的成片与录制现场存在差异属于常见现象。',
    time: '4 小时前',
    heat: '58.4 万',
    source: '综合网络公开讨论',
    tags: ['综艺', '剪辑', '镜头时长'],
    image:
      'https://readdy.ai/api/search-image?query=Television%20studio%20with%20rows%20of%20empty%20seats%20and%20warm%20amber%20stage%20lighting%20cutting%20through%20darkness%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20dramatic%20smoky%20atmosphere&width=800&height=450&seq=gossip-latest-06&orientation=landscape',
  },
  {
    id: 7,
    title: '选秀出身的歌手遭前经纪公司起诉，高额违约金传闻引发行业热议',
    category: '塌房现场',
    excerpt:
      '据公开信息显示，某选秀出身的歌手与前经纪公司的合约纠纷已进入司法程序。网络流传的违约金金额相当惊人，但相关数字尚未得到官方渠道证实。',
    detail:
      '演艺经纪合约通常约定较长的合作周期与较高比例的收益分成，一旦解约便可能触发违约条款。法律人士指出，违约金是否成立、数额是否合理，需要结合合约履行情况由法院认定，网络流传的数字不宜直接采信。目前案件的具体进展与结果仍有待官方信息披露。',
    time: '5 小时前',
    heat: '52.7 万',
    source: '综合网络公开讨论',
    tags: ['合约纠纷', '违约金', '选秀'],
    image:
      'https://readdy.ai/api/search-image?query=Legal%20documents%20and%20a%20gavel%20on%20a%20dark%20desk%20lit%20by%20warm%20amber%20light%2C%20cinematic%20editorial%20composition%2C%20moody%20high%20contrast%2C%20soft%20red%20accents%2C%20no%20people%2C%20no%20text%2C%20serious%20atmosphere&width=800&height=450&seq=gossip-latest-07&orientation=landscape',
  },
  {
    id: 8,
    title: '短剧顶流私下聚会视频流出，评论区对艺人私生活边界各执一词',
    category: '网红黑料',
    excerpt:
      '一段拍摄于私人包厢的短视频在网络传播，画面中多位短剧演员正在聚会。视频流出后，关于艺人私生活是否应被拍摄与传播的讨论迅速升温。',
    detail:
      '视频拍摄角度较为隐蔽，拍摄者身份不明。支持者认为艺人作为公众人物应注意言行，反对者则强调私人聚会属于个人空间，偷拍与传播涉嫌侵犯隐私。法律界人士提示，未经同意拍摄并公开他人非公开活动画面，可能涉及肖像权与隐私权问题。事件本身暂无当事人公开回应。',
    time: '6 小时前',
    heat: '47.9 万',
    source: '综合网络公开讨论',
    tags: ['短剧', '隐私边界', '聚会视频'],
    image:
      'https://readdy.ai/api/search-image?query=Dim%20private%20lounge%20with%20warm%20amber%20lamps%20and%20red%20velvet%20curtains%2C%20empty%20armchairs%2C%20cinematic%20editorial%20photography%2C%20moody%20high%20contrast%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20intimate%20atmosphere&width=800&height=450&seq=gossip-latest-08&orientation=landscape',
  },
  {
    id: 9,
    title: '头部主播选品再翻车，美妆产品资质问题被消费者集中追问',
    category: '直播带货',
    excerpt:
      '有消费者反映，在某头部主播直播间购买的美妆产品备案信息与实际宣传不符。主播团队表示已启动核查，若存在问题将依规处理，相关商品暂时下架。',
    detail:
      '消费者晒出的对比截图显示，产品包装标注的成分与直播间口播存在差异。第三方检测机构人士提醒，美妆产品的备案与功效宣传受严格监管，消费者可通过官方渠道查询备案编号。主播团队在回应中称，将配合品牌方厘清情况并保障消费者权益，后续处理结果会同步公布。',
    time: '8 小时前',
    heat: '43.6 万',
    source: '综合网络公开讨论',
    tags: ['选品', '美妆', '消费者维权'],
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20cosmetic%20bottles%20arranged%20on%20a%20dark%20surface%20under%20warm%20amber%20lighting%2C%20cinematic%20editorial%20product%20photography%2C%20moody%20high%20contrast%20with%20red%20accents%2C%20no%20people%2C%20no%20text%2C%20luxury%20minimal%20composition&width=800&height=450&seq=gossip-latest-09&orientation=landscape',
  },
];

export interface ExclusiveItem {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  detail: string;
  author: string;
  time: string;
  heat: string;
  image?: string;
}

export const exclusiveFeatured: ExclusiveItem = {
  id: 1,
  title: '深扒「塌房风暴」背后的舆论链条：一条爆料如何演变成全网事件',
  category: '独家观察',
  excerpt:
    '从一条模糊视频到登上讨论榜首，往往只需要几个小时。我们梳理了近期多起娱乐事件的传播路径，试图还原一条爆料从出现、扩散到反转的完整链条。',
  detail:
    '观察发现，多数事件都遵循相似的节奏：先是来源不明的素材在小圈子流传，接着被营销账号放大，随后官方或相关方作出回应，最后舆论在「相信」与「存疑」之间来回摆动。有趣的是，真正推动事件走向的往往不是最初的素材，而是各方回应时的措辞与时机。这篇观察不针对任何具体当事人，只讨论传播本身。我们坚持的观点是：吃瓜有趣，但事实更值得等待。',
  author: '吃瓜编辑部',
  time: '今天 09:20',
  heat: '112.4 万',
  image:
    'https://readdy.ai/api/search-image?query=Abstract%20network%20of%20glowing%20nodes%20and%20connecting%20lines%20spreading%20across%20a%20dark%20space%20with%20warm%20red%20and%20amber%20light%2C%20cinematic%20editorial%20technology%20visualization%2C%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20moody%20dramatic%20atmosphere&width=1200&height=640&seq=gossip-exclusive-feature&orientation=landscape',
};

export const exclusiveList: ExclusiveItem[] = [
  {
    id: 2,
    title: '明星与私生饭的攻防：为什么「跟拍」屡禁不止',
    category: '行业观察',
    excerpt:
      '从机场围堵到酒店蹲守，跟拍行为长期游走在灰色地带。本篇从法律与行业两个角度，聊聊艺人隐私保护的现实困境。',
    detail:
      '多位从业者提到，跟拍之所以难以根治，与素材的变现路径密切相关：照片与视频可以在粉丝圈层快速流转。法律层面，隐私权与公众知情权之间的边界需要个案判断。行业正在尝试通过行程保密、安保升级等方式应对，但效果仍有待观察。',
    author: '吃瓜观察员',
    time: '昨天 21:40',
    heat: '76.3 万',
  },
  {
    id: 3,
    title: '带货江湖的「信任账」：一次选品翻车要多久才能补回来',
    category: '行业观察',
    excerpt:
      '选品翻车正在成为直播行业的高频词。我们访谈了多位从业者，聊聊主播的信任成本到底由谁来承担。',
    detail:
      '从业者普遍认为，主播的核心资产是信任，而信任的损耗远比积累容易。一次质量事故可能让长期积累的口碑迅速打折。行业内的共识是：把好选品关、建立可追溯的售后机制，才是长期解法，而非事后公关。',
    author: '吃瓜观察员',
    time: '昨天 18:05',
    heat: '64.8 万',
  },
  {
    id: 4,
    title: '综艺剪辑的「剪刀手」逻辑：成片之外还发生了什么',
    category: '幕后揭秘',
    excerpt:
      '一档综艺的成片时长往往只有录制的几十分之一。了解剪辑逻辑，有助于观众更理性地看待镜头分配。',
    detail:
      '剪辑师介绍，成片需要在节奏、叙事与时长之间权衡，镜头分配并不完全等同于艺人的重要性。观众感到「剧情断裂」，有时确实源于档期调整或素材取舍。理性看待剪辑，是成熟吃瓜的一部分。',
    author: '幕后小组',
    time: '前天 23:10',
    heat: '51.2 万',
  },
];

export interface StarItem {
  id: number;
  name: string;
  title: string;
  claim: string;
  heat: string;
  tag: string;
  avatar: string;
}

export const starItems: StarItem[] = [
  {
    id: 1,
    name: '苏晚意',
    title: '顶流女演员被传片场「改戏」，编剧团队发长文回应',
    claim: '网络传闻称其对剧本提出大量修改意见，编剧团队回应称讨论属于正常创作磨合。',
    heat: '91.2 万',
    tag: '片场传闻',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20silhouette%20in%20warm%20amber%20backlight%20against%20a%20dark%20smoky%20background%2C%20cinematic%20editorial%20art%20photography%2C%20high%20contrast%2C%20face%20in%20shadow%2C%20no%20identifiable%20features%2C%20no%20text%2C%20moody%20elegant%20tone&width=400&height=400&seq=gossip-star-01&orientation=squarish',
  },
  {
    id: 2,
    name: '陆则言',
    title: '人气男演员被拍出入某高档餐厅，同行人员身份成谜',
    claim: '有媒体拍到其与数人共同用餐，画面模糊难以辨认同行者身份，本人团队暂未回应。',
    heat: '83.7 万',
    tag: '行程曝光',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20silhouette%20lit%20by%20red%20and%20amber%20neon%20glow%20on%20a%20dark%20backdrop%2C%20cinematic%20editorial%20art%20photography%2C%20high%20contrast%2C%20face%20in%20shadow%2C%20no%20identifiable%20features%2C%20no%20text%2C%20urban%20moody%20tone&width=400&height=400&seq=gossip-star-02&orientation=squarish',
  },
  {
    id: 3,
    name: '林知夏',
    title: '新生代歌手被指新歌旋律雷同，本人回应称纯属巧合',
    claim: '有网友对比后指出旋律走向相似，歌手工作室回应称创作独立完成，愿接受专业鉴定。',
    heat: '77.5 万',
    tag: '创作争议',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20silhouette%20surrounded%20by%20warm%20amber%20sound%20wave%20lines%20on%20dark%20background%2C%20cinematic%20editorial%20art%20photography%2C%20high%20contrast%2C%20no%20identifiable%20features%2C%20no%20text%2C%20moody%20artistic%20tone&width=400&height=400&seq=gossip-star-03&orientation=squarish',
  },
  {
    id: 4,
    name: '沈弋',
    title: '实力派演员被传与剧组不和，制片人出面辟谣称合作愉快',
    claim: '传闻称其与主创关系紧张，制片人公开表示拍摄期间沟通顺畅，望大家不要以讹传讹。',
    heat: '68.9 万',
    tag: '不和传闻',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20silhouette%20with%20soft%20amber%20rim%20light%20on%20a%20deep%20dark%20background%2C%20cinematic%20editorial%20art%20photography%2C%20high%20contrast%2C%20face%20unclear%2C%20no%20identifiable%20features%2C%20no%20text%2C%20serious%20moody%20tone&width=400&height=400&seq=gossip-star-04&orientation=squarish',
  },
  {
    id: 5,
    name: '白鹿鸣',
    title: '偶像剧男二被扒学历疑点，粉丝后援会呼吁理性看待',
    claim: '有网友质疑其就读经历，后援会表示个人资料以官方公示为准，请勿轻信网络传言。',
    heat: '61.4 万',
    tag: '资料质疑',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20silhouette%20against%20a%20warm%20amber%20gradient%20haze%20on%20dark%20background%2C%20cinematic%20editorial%20art%20photography%2C%20high%20contrast%2C%20no%20identifiable%20features%2C%20no%20text%2C%20soft%20moody%20tone&width=400&height=400&seq=gossip-star-05&orientation=squarish',
  },
  {
    id: 6,
    name: '许清和',
    title: '资深女星旧照被翻出，「容貌变化」话题再度登上讨论榜',
    claim: '旧照与新照被对比传播，本人尚未回应，网友观点分歧，多数人呼吁尊重个人选择。',
    heat: '55.8 万',
    tag: '旧照热议',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20silhouette%20beside%20a%20warm%20amber%20vintage%20light%20on%20a%20dark%20backdrop%2C%20cinematic%20editorial%20art%20photography%2C%20high%20contrast%2C%20no%20identifiable%20features%2C%20no%20text%2C%20nostalgic%20moody%20tone&width=400&height=400&seq=gossip-star-06&orientation=squarish',
  },
];

export interface InfluencerItem {
  id: number;
  name: string;
  platform: string;
  title: string;
  excerpt: string;
  heat: string;
  tags: string[];
  image: string;
}

export const influencerItems: InfluencerItem[] = [
  {
    id: 1,
    name: '阿钧的日常',
    platform: '短视频',
    title: '生活区顶流被指「剧本式」记录，团队化运营痕迹明显',
    excerpt:
      '多条视频中出现的路人反应高度一致，被网友质疑经过提前安排。博主回应称内容来自真实生活，剪辑会更紧凑但不会造假。',
    heat: '72.6 万',
    tags: ['剧本质疑', '生活区'],
    image:
      'https://readdy.ai/api/search-image?query=Empty%20urban%20street%20corner%20with%20warm%20amber%20and%20red%20neon%20signs%20in%20the%20evening%2C%20cinematic%20editorial%20photography%2C%20moody%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20atmospheric%20city%20tone&width=600&height=400&seq=gossip-inf-01&orientation=landscape',
  },
  {
    id: 2,
    name: '糖糖测评室',
    platform: '图文社区',
    title: '测评博主被品牌方质疑「恶意对比」，双方各执一词',
    excerpt:
      '博主在某期测评中给出较低评分，品牌方认为对比条件不公平。博主回应称测试方法公开，欢迎复现，争议暂未平息。',
    heat: '65.1 万',
    tags: ['测评争议', '品牌反馈'],
    image:
      'https://readdy.ai/api/search-image?query=Neat%20row%20of%20unlabeled%20product%20boxes%20on%20a%20dark%20table%20under%20warm%20amber%20light%2C%20cinematic%20editorial%20product%20photography%2C%20moody%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20clean%20minimal%20tone&width=600&height=400&seq=gossip-inf-02&orientation=landscape',
  },
  {
    id: 3,
    name: '老周说车',
    platform: '长视频',
    title: '汽车博主与厂商公开互怼，试驾数据真实性成焦点',
    excerpt:
      '一期试驾视频引发厂商不满，双方围绕测试环境与数据口径展开争论。业内呼吁以第三方机构复测为准。',
    heat: '58.3 万',
    tags: ['数据争议', '汽车'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20glowing%20speed%20lines%20and%20dashboard%20shapes%20in%20a%20dark%20studio%20with%20red%20and%20amber%20light%2C%20cinematic%20editorial%20technology%20background%2C%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20dynamic%20moody%20tone&width=600&height=400&seq=gossip-inf-03&orientation=landscape',
  },
  {
    id: 4,
    name: '晚风小厨',
    platform: '短视频',
    title: '美食博主被曝团队代拍，出镜与后厨人员并非同一人',
    excerpt:
      '有网友对比不同期视频的手部细节，指出出镜者并不固定。博主未正面回应，仅在评论区表示团队分工正常。',
    heat: '49.7 万',
    tags: ['代拍质疑', '美食'],
    image:
      'https://readdy.ai/api/search-image?query=Warm%20home%20kitchen%20counter%20with%20steaming%20pans%20under%20amber%20light%2C%20cinematic%20editorial%20food%20photography%2C%20moody%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20cozy%20atmospheric%20tone&width=600&height=400&seq=gossip-inf-04&orientation=landscape',
  },
  {
    id: 5,
    name: '穿搭研究所',
    platform: '图文社区',
    title: '时尚博主被指「货不对板」，同款链接实物与展示差距大',
    excerpt:
      '多位粉丝反映，按博主推荐购买的同款服饰与展示效果差距明显。博主称展示图未做过度修图，会协助粉丝处理售后。',
    heat: '44.2 万',
    tags: ['带货口碑', '服饰'],
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20clothing%20rack%20with%20unlabeled%20garments%20under%20warm%20amber%20spotlights%20in%20a%20dark%20boutique%2C%20cinematic%20editorial%20fashion%20photography%2C%20moody%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20refined%20tone&width=600&height=400&seq=gossip-inf-05&orientation=landscape',
  },
  {
    id: 6,
    name: '山野漫游',
    platform: '长视频',
    title: '户外博主被质疑「摆拍求险」，安全示范引发争议',
    excerpt:
      '一期野外视频中的危险动作被指缺乏安全提示。博主回应称已做充分准备，并在片尾补充安全说明，接受批评。',
    heat: '39.5 万',
    tags: ['安全争议', '户外'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20mountain%20silhouettes%20in%20warm%20amber%20haze%20at%20dusk%20over%20a%20dark%20landscape%2C%20cinematic%20editorial%20outdoor%20photography%2C%20moody%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20atmospheric%20tone&width=600&height=400&seq=gossip-inf-06&orientation=landscape',
  },
];

export interface TimelineStep {
  id: number;
  time: string;
  title: string;
  desc: string;
}

export const timelineSteps: TimelineStep[] = [
  {
    id: 1,
    time: '第 1 天 深夜',
    title: '来源不明的素材出现',
    desc: '一段低清晰度的短视频在数个小型娱乐讨论群组中出现，此时尚未形成广泛传播，多数网友处于观望状态。',
  },
  {
    id: 2,
    time: '第 2 天 上午',
    title: '营销账号开始跟进',
    desc: '多个娱乐类账号以截图加配文的形式跟进，标题带有明显的猜测性语气，话题热度开始攀升并进入公共视野。',
  },
  {
    id: 3,
    time: '第 2 天 下午',
    title: '相关方首次回应',
    desc: '艺人的后援会率先发布声明，呼吁粉丝理性，并强调以官方渠道信息为准。声明本身又引发了新一轮解读。',
  },
  {
    id: 4,
    time: '第 3 天',
    title: '话题登上讨论榜',
    desc: '相关词条进入平台讨论榜前列，正反双方展开激烈讨论，同时出现了大量二次创作与衍生话题。',
  },
  {
    id: 5,
    time: '第 3 天 晚间',
    title: '出现新的信息片段',
    desc: '有网友补充了时间线更完整的素材，部分此前的说法被修正，舆论开始从「一边倒」转向「多方存疑」。',
  },
  {
    id: 6,
    time: '第 4 天',
    title: '官方或工作室回应',
    desc: '相关工作室发布较为正式的说明，对关键争议点作出回应，各方态度趋于谨慎，热度开始从高点回落。',
  },
  {
    id: 7,
    time: '第 5 天 至今',
    title: '讨论转入长尾',
    desc: '事件热度下降，讨论更多集中在行业现象与隐私边界等延伸话题上。最终结论仍以当事人官方信息为准。',
  },
];

export interface RankItem {
  id: number;
  title: string;
  category: string;
  heat: string;
  value: number;
}

export const rankingItems: RankItem[] = [
  { id: 1, title: '顶流男团成员深夜接机神秘女子', category: '明星黑料', heat: '98.6 万', value: 100 },
  { id: 2, title: '千万粉主播刷单冲榜疑云', category: '直播带货', heat: '86.2 万', value: 88 },
  { id: 3, title: '新晋小花剧组耍大牌传闻', category: '明星黑料', heat: '74.5 万', value: 76 },
  { id: 4, title: '网红情侣账号被指公司运营', category: '网红黑料', heat: '63.1 万', value: 64 },
  { id: 5, title: '演员夫妇婚变传闻再起', category: '情感纠葛', heat: '69.8 万', value: 61 },
  { id: 6, title: '综艺剪辑争议持续发酵', category: '综艺风波', heat: '58.4 万', value: 56 },
  { id: 7, title: '选秀歌手合约纠纷进入司法程序', category: '塌房现场', heat: '52.7 万', value: 52 },
  { id: 8, title: '短剧顶流私下聚会视频流出', category: '网红黑料', heat: '47.9 万', value: 47 },
  { id: 9, title: '头部主播美妆选品资质争议', category: '直播带货', heat: '43.6 万', value: 43 },
  { id: 10, title: '人气男演员行程曝光引热议', category: '明星黑料', heat: '38.9 万', value: 38 },
];

export const siteStats: { id: number; label: string; value: string }[] = [
  { id: 1, label: '今日新增爆料', value: '128' },
  { id: 2, label: '独家深度稿件', value: '46' },
  { id: 3, label: '覆盖明星 · 网红', value: '320+' },
  { id: 4, label: '累计吃瓜人次', value: '1.8 亿' },
];